module.exports = __webpack_public_path__ + "img/empty-box.202703b1.svg";